// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { DataPrivacyViolationRepoService } from '../../services/api/data-privacy-violation-repo/data-privacy-violation-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LIKELIHOODS } from '@client/ng2/modules/data-privacy/constants/data-privacy-likelihood.constant';
import { REGULATIONS } from '../../constants/regulations.constant';
import { INFOTYPE_GROUPS } from '../../constants/infotype-groups.constant';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { DataPrivacyService } from '../../services/data-privacy/data-privacy.service';
import { DataPrivacyEntitiesViolationService } from '../../services/entities/violation.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    PrivacyDialogsHelpCenterComponent,
} from '@client/app/modules/data-privacy/dialogs/help-center/help-center.component';
import {
    PrivacyViolationPagesComponent,
} from '@client/app/modules/data-privacy/dialogs/violation-pages/privacy-violation-pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'privacy-issues',
    standalone: false,
    template: `
        <div class="data-privacy"
             id="data-privacy-issues">
            <page-header
                    [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'ISSUES'] | monIcons"
                    [header]="'Issues by Type' | translate"
                    [subHeader]="(violations.total || '') + ' ' + ('violations' | translate)">
            </page-header>
            <mon-tabs
                    [options]="tabs"
                    [(status)]="activeTab"
                    (onStatus)="onStatus($event)"
                    (onSearch)="onSearch($event)"
                    [search]="search"
                    [minSearchLength]="1"
                    [maxOptionsDisplay]="6"
                    [showFiltersBtn]="showFilters"
                    [(isFiltersOpen)]="isFiltersOpen"
                    [showSearch]="true">
                <csv-export-button [exports]="exports"></csv-export-button>
            </mon-tabs>
            <div class="bg-white mt-1 panel-monsido-card">
                <div class="card-body">
                    <table-container [noResultMessage]="'Good job! No violations were found' | translate"
                                     [collection]="violations"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     [progress]="progress"
                                     class="pages-table-wrapper"
                    >
                        <table-container-top>
                            <div class="outer-b merge-r-36 merge-l-36 merge-t-10"
                                 *ngIf="isFiltersOpen">
                                <table-filters [(open)]="isFiltersOpen"
                                               [(ngModel)]="filters"
                                               name="filters"
                                               [filters]="availableFilters"
                                               (onChanges)="onFiltersChanges($event)">
                                </table-filters>
                            </div>
                        </table-container-top>
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th monTableSort
                                    class="text-left type-cell text-v-middle"
                                    [monSortBy]="'group'"
                                    [monThTitle]="'Type' | translate"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                </th>
                                <th class="text-left"
                                    translate>
                                    Issue
                                </th>
                                <th monTableSort
                                    class="text-left text-v-middle"
                                    [monSortBy]="'name'"
                                    [monThTitle]="'Check name' | translate"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                </th>
                                <th monTableSort
                                    [monSortDirection]="currentSort.direction"
                                    [monSortBy]="'likelihood'"
                                    [monThTitle]="'Likelihood' | translate"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    class="text-right text-v-middle">
                                    <span class="outer-l-smurf fas fa-question-circle"
                                          aria-hidden="true"
                                          [ngbTooltip]="'The likelihood of this being a Data Privacy issue' | translate"
                                          [triggers]="'focus hover'">
                                    </span>
                                </th>
                                <th class="text-right text-v-middle"
                                    translate>
                                    Help center
                                </th>
                                <th monTableSort
                                    [monSortDirection]="currentSort.direction"
                                    [monSortBy]="'page_count'"
                                    [monThTitle]="'Pages' | translate"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    class="text-right text-v-middle">
                                </th>
                                <th class="text-right text-v-middle p-0">
                                    <div>
                                        <span class="table-cell-fill-content d-flex justify-content-end align-items-center"
                                              monTableSort
                                              *ngIf="activeTab === 'ignored' || activeTab === 'fixed'"
                                              [monSortDirection]="currentSort.direction"
                                              [monSortBy]="'priority'"
                                              [monThTitle]="'Severity' | translate"
                                              [monCurrentlySortedBy]="currentSort.by"
                                              (monOnSorted)="onMonTableSort($event)">
                                        </span>
                                        <span class="table-cell-fill-content d-flex justify-content-end align-items-center table-head-label-without-sort"
                                              *ngIf="activeTab !== 'ignored' && activeTab !== 'fixed'"
                                              translate>
                                            Severity
                                        </span>
                                    </div>
                                </th>
                                <th class="text-right text-v-middle"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let violation of violations">
                                <td class="text-left type-cell text-v-middle">
                                    <mon-data-privacy-info-type-icon [monGroup]="violation.info_type.group"
                                                                     [monPriority]="violation.info_type.priority"
                                                                     [monTooltipText]="formatText(violation.info_type.group || 'other') | translate">
                                    </mon-data-privacy-info-type-icon>
                                </td>
                                <td class="text-v-middle">
                                    {{ violation.content }}
                                </td>
                                <td class="text-v-middle">
                                    {{ violation.info_type.name }}
                                </td>
                                <td class="text-right text-v-middle">
                                    {{ getLikelihood(violation) }}
                                </td>
                                <td class="text-right text-v-middle">
                                    <span (click)="openHelpCenter(violation.info_type)"
                                          role="button"
                                          [attr.aria-label]="'Go to help center' | translate"
                                          monEventTrigger="actionTrigger"
                                          [monEventParams]="{action:'accessibility-help-center-btn'}"
                                          class="cursor-pointer text-link fas fa-graduation-cap help-center-icon"
                                          tabindex="0">
                                    </span>
                                </td>
                                <td class="text-right text-v-middle">
                                    <pages-button (callback)="goToPages(violation, true)"
                                                  [ngModel]="violation.page_count"></pages-button>
                                </td>
                                <td class="text-right text-v-middle">
                                    <mon-data-privacy-severity-level [monPriority]="violation.info_type.priority"
                                                                     *ngIf="!loading"></mon-data-privacy-severity-level>
                                </td>
                                <td class="text-right text-v-middle">
                                    <mon-data-privacy-dropdown [monViolation]="violation"
                                                               [monActiveTab]="activeTab"
                                                               (monUpdateCallback)="update($event.status, $event.violation, $event.confirmMessage)">
                                    </mon-data-privacy-dropdown>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyIssuesComponent extends BaseContainerComponentController implements OnInit {
    violations: any = [];
    tabs: any;
    override showFilters: boolean = false;
    override filters: any = { 'Data Regulations': [], 'Issue type': [] };
    override availableFilters = {
        'Data Regulations': REGULATIONS,
        'Issue type': INFOTYPE_GROUPS.sort((a, b) => {
            if (a.value === 'other') {
                return 1;
            }
            if (b.value === 'other') {
                return -1;
            }
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        }),
    };
    override isFiltersOpen: boolean = false;
    exports: any = [];
    progress: any;
    loading: boolean = false;
    update: any;
    private pageCount: number = 0;

    constructor (
        private dataPrivacyViolationRepoService: DataPrivacyViolationRepoService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
        private dataPrivacyService: DataPrivacyService,
        private dataPrivacyEntitiesViolationService: DataPrivacyEntitiesViolationService,
        private monEventService: MonEventService,
        private monModalService: MonModalService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.violations = [];
        this.tabs = [
            {
                name: this.translateService.getString('All'),
                value: 'all',
            },
            {
                name: this.translateService.getString('High'),
                value: 'high',
            },
            {
                name: this.translateService.getString('Medium'),
                value: 'medium',
            },
            {
                name: this.translateService.getString('Low'),
                value: 'low',
            },
            {
                name: this.translateService.getString('Ignored'),
                value: 'ignored',
            },
            {
                name: this.translateService.getString('Fixed'),
                value: 'fixed',
            },
        ];
        this.activeTab = this.tabs[0].value;
        this.currentSort = { by: 'identifier', direction: 'asc' };
        this.showFilters = this.activeFeatureService.isFeatureActive('table_filters');
        this.isFiltersOpen = false;

        this.exports = [
            {
                name: this.translateService.getString('Issues by Type'),
                data: {
                    category: 'data_protection_violations',
                },
            },
        ];

        this.getPage();
        this.update = (status: any, violation: any, confirmMessage: any) => {
            this.monModalService.confirm(confirmMessage).then(() => {
                const violationToUpdate = safeClone(violation);
                violationToUpdate.status = status;
                this.dataPrivacyEntitiesViolationService.update(violationToUpdate).then(() => {
                    this.getPage();
                }, () => {});
            });
        };
    }

    override getPage = (): void => {
        const params: any = {
            search: this.search,
            page: this.page,
            page_size: this.pageSize,
            sort_dir: this.currentSort.direction,
            sort_by: this.currentSort.by,
        };

        if (this.activeTab !== 'fixed' && this.activeTab !== 'ignored') {
            if (this.activeTab !== 'all') {
                params.priority = this.activeTab;
            }
            params.status = 'active';
        } else {
            params.status = this.activeTab;
        }

        params['regulations[]'] = this.filters['Data Regulations'].map((regulation: any) => {
            return regulation.value;
        });
        params['group[]'] = this.filters['Issue type'].map((type: any) => {
            return type.value;
        });

        this.progress = this.dataPrivacyViolationRepoService.getAll(null as any, params).then((violations: any) => {
            this.violations = violations;
            this.pageCount = parseInt(this.violations.total, 10);
            this.updateDropdowns();
        }, () => {});
    };

    formatText (text) {
        return this.dataPrivacyService.formatText(text);
    }

    getLikelihood (violation: any): string {
        if (LIKELIHOODS[violation.likelihood]) {
            return this.dataPrivacyService.getViolationLikelihood(violation);
        } else {
            return this.translateService.getString('Likelihood unspecified');
        }
    }

    onFiltersChanges (changes: any): void {
        this.filters = changes;
        this.getPage();
    }

    /**
     * @param issue - a infotype or violation object
     * @param violation - boolean to determine if violation
     */
    goToPages (issue: any, violation: boolean): void {
        let params: any = {};
        if (!violation) {
            params = {
                size: 'lg',
                body: PrivacyViolationPagesComponent,
                data: { infoType: issue, totalPagesCount: this.pageCount },
            };
        } else {
            params = {
                size: 'lg',
                body: PrivacyViolationPagesComponent,
                data: { violation: issue, totalPagesCount: this.pageCount },
            };
        }

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    openHelpCenter (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyDialogsHelpCenterComponent,
            data: { infoType: infoType },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    private updateDropdowns (): void {
        // Implementation for updating dropdowns if needed
    }
}
